import { Component, Inject, Input, LOCALE_ID, OnInit } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { BaseInputComponent } from '../../base/base-input/base-input.component';

@Component({
  selector: 'carm-input-field',
  templateUrl: './input-field.component.html',
  styleUrls: ['./input-field.component.scss'],
  viewProviders: [
    { provide: ControlContainer, useExisting: FormGroupDirective },
  ],
})
export class InputFieldComponent extends BaseInputComponent implements OnInit {
  @Input() inMaxLength: number;
  @Input() inMinLength: number;
  @Input() readonly: boolean;
  @Input() upperCase: boolean;
  @Input() inMask: string;
  @Input() inMaskValidation: boolean;
  @Input() fitToSize = false;
  @Input() showMaxLength = false;
  @Input() inDropSpecialCharacters: boolean | string[];
  @Input() currency: string;
  @Input() inAllowNegativeNumbers: boolean;
  @Input() inThousandSeparator: string;
  @Input() inSeparatorLimit: string;
  @Input() displayErrors = true;
  @Input() inDecimalMarker: string = '.';
  @Input() alphanumericOnly = false;

  constructor(@Inject(LOCALE_ID) public localeId: string) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.setPostalCodeLength();
  }

  private setPostalCodeLength(): void {
    this.inMaxLength = this.inMask === 'A0A 0A0||a0a 0a0' ? 7 : this.inMaxLength;
  }
}
